var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstantReplies({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00b538;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.28,31.43c-1.29,0-1.86-1.57-1-2.43l10-10c.57-.57,1.43-.57,2,0l4.71,4.71,12.29-12.29h-5.14c-.86,0-1.43-.57-1.43-1.43s.57-1.43,1.43-1.43h8.57c.86,0,1.43.57,1.43,1.43v8.57c0,.86-.57,1.43-1.43,1.43s-1.43-.57-1.43-1.43v-5.14l-13.29,13.29c-.57.57-1.43.57-2,0l-4.71-4.71-9,9c-.29.29-.57.43-1,.43Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstantReplies);
export default __webpack_public_path__ + "static/media/instant-replies.bf16e019c447ced8ca475693138d7fc2.svg";
export { ForwardRef as ReactComponent };